// Added by Sejune Oh on 2019-07-11
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import { action, makeObservable, observable } from 'mobx'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Root store
import Rootstore from '../../index'

// Store
import DataStorageStoreBase from '../../base/DataStorageStoreBase'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Interface
interface StudyTagBaseElementProps {
  id?: string
  name?: string
  description?: string
  proxy_token?: string
  created_at?: string
  updated_at?: string
}

export interface StudyTagElementProps extends StudyTagBaseElementProps {
  tag_name?: string
  tag_description?: string
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export default class DataStorageStudyTagStore extends DataStorageStoreBase<StudyTagElementProps> {
  totalCount: number = 0
  elements: Array<StudyTagElementProps> = []
  cachedElements: Array<StudyTagElementProps> = []
  root?: Rootstore

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  constructor(root: Rootstore) {
    super({
      storeName: 'DS_StudyTag',
      apiSubUrl: 'config/study-tags',
      _root: root,
    })
    this.root = root
    makeObservable(this, {
      totalCount: observable,
      elements: observable,
      cachedElements: observable,
      _setTotalCount: action,
      setElements: action,
      cachedStore: action,
      clearCachedStore: action,
    })
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  getElements = async (path?: string) => {
    /** MGMT에서는 항상 모든 tag를 visible하게 가져오므로 다른 params이 없더라도 default로 보내도록 한다 */
    const queryParam = path ? `${path}&include_invisible_tags=true` : 'include_invisible_tags=true'
    const rtnData = await super.getAll(queryParam)
    await this._setTotalCount(parseInt(rtnData.total_count as string))
    return rtnData.items as StudyTagElementProps[]
  }

  addElement = async (element: StudyTagElementProps) => {
    const newElement = await super.add(element)
    return newElement.id
  }

  updateElement = async (id: string, element: StudyTagElementProps) => {
    return super.update(id, element)
  }

  removeElement = async (id: string) => {
    return super.remove(id)
  }

  checkDuplicatedName = (ruleName: string) => {
    return super.checkDuplicatedByField({ field: 'name', value: ruleName })
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  _setTotalCount = (count: number) => {
    this.totalCount = count
  }

  setElements = (elements: Array<StudyTagElementProps>) => {
    this.elements = elements
  }

  cachedStore = (elements: Array<StudyTagElementProps>) => {
    this.cachedElements = elements
  }

  clearCachedStore = () => {
    this.cachedElements = []
  }
}
